export default __webpack_public_path__ + "static/media/Weather_13.31569588.png";